import { ref, computed } from 'vue'

import { useAuthenticationData } from '@/composables/useAuthenticationData'
import { fetchTrainingOverview } from '@streampac.io/chef_sp_1'

// Create a single shared instance
const totalTrainings = ref(0)
const successfulTrainings = ref(0)
const trainingData = ref([])
const totalPipes = ref(40)
const totalPipesMobile = ref(30)

// Computed properties
const successPercentage = computed(() => {
  return totalTrainings.value > 0
    ? Math.round((successfulTrainings.value / totalTrainings.value) * 100)
    : 0
})

const isAuthenticated = computed(() => {
  return useAuthenticationData().data.value.isAuthenticated
})

const fetchDataParams = ref({
  filter: {
    searchTerm: '',
    queryCondition: 'AND',
    type: 'PublicTraining;CustomerGroupTraining',
    typeQueryCondition: 'OR'
  },
  paging: {
    pageNumber: 1,
    pageSize: 200
  },
  orderBy: {
    orderByField: 'sortOrder',
    orderDesc: false
  }
})

const completedPipes = computed(() => {
  return Math.round((successfulTrainings.value / totalTrainings.value) * totalPipes.value)
})

const completedPipesMobile = computed(() => {
  return Math.round((successfulTrainings.value / totalTrainings.value) * totalPipesMobile.value)
})

// Methods
const updateTrainingData = (data: any[]) => {
  //   console.log('Updating training data:', data) // Debug log
  trainingData.value = data as never[]
  totalTrainings.value = data.length
  successfulTrainings.value = 0

  //console.log('updateTrainingData', data)

  data.forEach((item) => {
    if (item.userTraining && item.userTraining.isSucceed === true) {
      successfulTrainings.value += 1
    }
  })
}

const triggerGetTrainingProgress = () => {
  fetchTrainingOverview(
    isAuthenticated.value,
    fetchDataParams.value,
    '?isFlattenFieldsVisible=true&isUserTrainingIncluded=true',
    true
  ).then((response: any) => {
    if (response.data && response.data.length > 0) {
      updateTrainingData(response.data)
    }
  })
}

export function useTrainingProgress() {
  return {
    // State
    totalTrainings,
    successfulTrainings,
    trainingData,
    totalPipes,
    totalPipesMobile,
    // Computed
    successPercentage,
    completedPipes,
    completedPipesMobile,
    // Methods
    updateTrainingData,
    triggerGetTrainingProgress
  }
}
